/**
 * Accordion Component
 * Expandable accordion with smooth collapse animation
 */

import type { Magics } from 'alpinejs';

interface AccordionData {
    isOpen: boolean;
    toggle(): void;
}

type AccordionContext = AccordionData & Magics<AccordionData>;

export default function accordion() {
    return {
        // Component state
        isOpen: false,

        // Toggle accordion
        toggle() {
            this.isOpen = !this.isOpen;
        },
    } as AccordionData;
}
